import React, { useEffect, useRef, useState } from 'react'
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo.png'
import menuService from '../../api/menu.service';
import { Button } from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  TeamOutlined,
  UserOutlined,
  MailOutlined,
  AppstoreOutlined,
  SettingOutlined,
  DownloadOutlined,
  PoweroffOutlined,
  DoubleRightOutlined,
  RightCircleOutlined,
  RightSquareOutlined,
  RightOutlined
} from '@ant-design/icons'
import commonUtility from '../../utility/Utils';
import { DOMAIN_URL } from '../../utility/URL';

const ProSidebarMenu = (props) => {
  const navigate = useNavigate();
  const [menuBar, setMenuBar] = useState([]);
  // const [menuData, setMenuData] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState('');
  const [year, setYear] = useState("");


  useEffect(() => {
    let sessionData = commonUtility.getLoggedInUserInfo();
    // previous code
    // setYear(sessionData.yearData.year);

    // Modified - 5/4/24
    sessionData ? setYear(sessionData.yearData.year) : setYear("");
  });

  const handleMenuClick = (url, is_php) => {
    // console.log("first", is_php);
    // console.log("url",DOMAIN_URL+url);
    if (is_php === "Y") {
      window.location.href = DOMAIN_URL + url;
    } else {
      navigate(url);
    }
    // console.log(url)

    setSelectedMenu(url);
    window.scrollTo(0, 0)
  };



  useEffect(() => {

    const getMenuByID = async () => {

      await menuService.menulistbyUser().then((s) => {
        // console.log(s);
        let menuData = s;
        const hashTable = Object.create(null);
        let item = {};
        menuData.forEach(aData => {
          item = {
            label: aData.name,
            key: aData.id,
            id: aData.id,
            icon: "",
            parent_id: aData.parent_id,
            link: aData.link,
            is_php: aData.is_php,
          }
          // console.log(item);
          hashTable[item.id] = { ...item, children: [] }
        }
        );
        const dataTree = [];
        menuData.forEach(aData => {
          item = {
            label: aData.name,
            key: aData.id,
            id: aData.id,
            icon: "",
            parent_id: aData.parent_id,
            link: aData.link,
            is_php: aData.is_php,
          }

          if (item.parent_id) {
            hashTable[item.parent_id].children.push(hashTable[item.id])
          }
          else {

            dataTree.push(hashTable[item.id])
          }
        });

        const x = removeEmptyElements(dataTree);
        setMenuBar(x);
      });

    }

    getMenuByID();

  }, [localStorage.getItem('user')]);



  const removeEmptyElements = (obj) => {
    if (Array.isArray(obj)) {
      obj.forEach((element, index) => obj.splice(index, 1, removeEmptyElements(element)));
      return obj;
    }
    return Object.fromEntries(Object.entries(obj)
      .filter(([, v]) => (Array.isArray(v) ? v.length !== 0 : (v !== null && v !== '' && v !== undefined)))
      .map(([k, v]) => [k, v === (Object(v)) ? removeEmptyElements(v) : v]));
  }

  const renderMenu = (menu) => {
    return (
      menu.children ?
        <SubMenu key={menu.key} label={menu.label} icon={<RightSquareOutlined />} >
          {menu.children
            ? menu.children.map((childMenu) => renderMenu(childMenu))
            : <MenuItem key={menu.key} onClick={() => handleMenuClick(menu.link, menu.is_php)} active={selectedMenu === menu.link} icon={<DoubleRightOutlined />} >{menu.label}</MenuItem>}
        </SubMenu>
        :
        <MenuItem key={menu.key} onClick={() => handleMenuClick(menu.link, menu.is_php)} active={selectedMenu === menu.link} icon={<DoubleRightOutlined />} >{menu.label}</MenuItem>

    );
  };


  const handleLogout = async () => {
    // logout
    localStorage.removeItem("user");
    navigate("/login");
  };



  return (
    <>

      <Sidebar style={{
        position: 'fixed',
        width: '250px',
        height: '100%',
        top: 0,
        left: 0,

      }}
        className="customSider"
        ref={props.refrence}
      >

        <div className="sidebar-logo-container">
          <Link to="/dashboard">
            <img src={logo} className="sidebar-logo" alt="logo" />
          </Link>

          <h1 className="sidebar-title">BENGAL TENNIS ASSOCIATION</h1>
          <h1 className="sidebar-title">{year}</h1>
        </div>

        <Menu>
          {menuBar.map((menu) => renderMenu(menu))}
          <MenuItem key={`menu-logout`}>
            <Button type="text" shape="round" icon={<PoweroffOutlined />} size="middle"
              onClick={handleLogout}
            >
              Logout
            </Button>
          </MenuItem>
        </Menu>
      </Sidebar>
    </>
  )
}

export default ProSidebarMenu;